import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { addSubTasks, updateSubTasks } from '../../actions/userActions/subTaskAction'
import Loader from '../subComponents/Loader'
import { Redirect, useLocation, useHistory } from 'react-router-dom';
import BodyExtraSmallMedium from '../designSystem/BodyExtraSmallMedium';
import BodySmallRegular from '../designSystem/BodySmallRegular';
import subtaskIcon from "../../assets/images/subtaskIcon.svg";
import closeModal from "../../assets/images/closeModal.svg";
import BodyLargeMedium from '../designSystem/BodyLargeMedium';
import { IconButton } from '@mui/material';
import { validateFields } from '../../utils/Validations';
import Textarea from '../designSystem/TextArea';
import TextField from '../designSystem/TextField';
import { Check, X } from 'lucide-react';
import BodySmallMedium from '../designSystem/BodySmallMedium';

import CancelButton from '../subComponents/buttons/CustomCancelButton';
import PrimaryButton from '../subComponents/buttons/PrimaryButton';
import { t } from '../../locales/translate';
function AddSubTasks({ onClose, editData, onSave }) {

  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const initialValues = { name: "", description: "", active: false };
  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  useEffect(() => {
    if (editData) {
      setFormValues(editData);
    }
  }, [editData]);
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormValues({
      ...formValues,
      [name]: type === "checkbox" ? checked : value,
    });
  };
  const handleSave = async (e) => {
    e.preventDefault();
    const errors = validateFields(formValues, 'subtask');
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      if (editData) {
        const updatedSubTask = {
          ...formValues,
          status: formValues.active ? "Active" : "Inactive",
        };
        await dispatch(updateSubTasks(updatedSubTask));
      } else {
        await dispatch(addSubTasks(formValues));
      }
      await onSave(formValues);
    }
  };
  const validate = (values) => {
    const errors = {};

    if (!values.name) {
      errors.name = REQUIRED_MESSAGE("Name");
    } else if (values.name.length > MAX_NAME_LENGTH) {
      errors.name = MAX_LENGTH_MESSAGE("Name", MAX_NAME_LENGTH);
    }

    if (!values.description) {
      errors.description = REQUIRED_MESSAGE("Description");
    } else if (values.description.length > MAX_DESCRIPTION_LENGTH) {
      errors.description = MAX_LENGTH_MESSAGE("Description", MAX_DESCRIPTION_LENGTH);
    }

    return errors;
  };


  return (
    <>
      <div className="dynamicmodal-overlay">
        <div className="dynamicmodal-container">
          <div className="dynamicmodal-header mb-3">
            <div className="dynamicmodal-header-left">
              <div className="icon">
                <img src={subtaskIcon} alt="subtasks" />
              </div>
              <div className="text">
                <h2 className="modalheading">
                  {editData ? "Edit SubTasks" : `${t("addSubTasks")}`}
                </h2>
                <p className="modaldescription">
                  {t("addSubTasksTip")}
                </p>
              </div>
            </div>
            <div className="dynamicmodal-header-right">
              <IconButton onClick={onClose}>
                <img src={closeModal} alt="" />
              </IconButton>
            </div>
          </div>


          <form onSubmit={handleSave}>
            <div className="dynamicmodal-body">

              <TextField
                name="name"
                label={`${t("name")} *`}
                type="text"
                value={formValues.name}
                onChange={handleChange}
                placeholder={t("name")}
                error={formErrors.name}
              />
              <Textarea
                name="description"
                label={`${t("description")} *`}
                placeholder={t("description")}
                value={formValues.description}
                onChange={handleChange}
                error={formErrors.description}
              />

              <div className=" mt-2 ml-0">
                <div
                  className="form-group"
                  style={{ display: "flex", alignItems: "flex-start" }}
                >
                  <input
                    name="active"
                    style={{ cursor: "pointer", height: "14px", width: "14px" }}
                    type="checkbox"
                    checked={formValues.active}
                    className="ml-1 mt-1"
                    onChange={handleChange}
                  />
                  <label
                    style={{ paddingLeft: "5px" }}
                    className="form-control-label"
                  >
                    <div style={{ padding: '2px' }}>
                      <BodySmallMedium text={t("active")} color="#1E293B" />
                    </div>
                  </label>
                </div>
              </div>
            </div>
            <div className="dynamicmodal-footer">
              <CancelButton
              onClick={onClose}
              text={t("cancel")}
              width={document.body.dir === "rtl" ? "119px" : ""}
              />
              <PrimaryButton
              text={t("save")}
              icon={Check}
              width={document.body.dir === "rtl" ? "123px" : ""}
              />
            </div>
          </form>
        </div>
      </div>
    </>
  )
}

export default AddSubTasks
